// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__mgyYK","productName":"Table_productName__1AMvj"};